/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import React, { FC } from "react"
import { Tag } from "@duxton-web/ui"

interface ReturnRefundStatusTagProps {
  /** Server-rendered status text, straight off the worklist's `requestStatusContent`. */
  label: string
  /**
   * Whether to emphasise the label in red. The caller decides, because the rule differs by
   * surface: request-level rows key off the bucket alone, while item-level rows also require
   * the item to be one driving the request's status.
   */
  actionRequired: boolean
}

/**
 * The worklist's request-level status label, shared by the Orders and Feedback tabs.
 *
 * Two colours by design, so a merchant can scan for what needs them. The label is the server's
 * own text, so this renders any status the backend introduces without a FE change — unlike
 * `ReturnStatusTag`, which maps a fixed FE `ReturnStatus` enum to four colours.
 *
 * Colour comes from Duxton's status presets rather than local classes, so the tag inherits the
 * theme's own fill, border and text for each state and stays correct if the theme is retuned.
 */
export const ReturnRefundStatusTag: FC<ReturnRefundStatusTagProps> = ({
  label,
  actionRequired,
}) => <Tag color={actionRequired ? "error" : "default"}>{label}</Tag>
